import {
  IPersonaStyleProps,
  IPersonaStyles,
  PersonaSize,
  sizeBoolean
} from '@fluentui/react/lib/Persona';
import { FontWeights, ITheme } from '@fluentui/react/lib/Styling';
import { FontSizes } from '../teams-type';

export function getPersonaStyles(_themeName: string, theme: ITheme) {
  return (props: IPersonaStyleProps): Partial<IPersonaStyles> => {
    const size = sizeBoolean(props.size as PersonaSize);

    const styles = {
      callout: {
        padding: '100px'
      },
      root: [
        {
          padding: '12px 15px',
          boxSizing: 'content-box',
          selectors: {
            ':hover': {
              background: theme.palette.neutralLight,
              selectors: {
                '.ms-Persona-primaryText': {
                  color: theme.palette.black
                }
              }
            },
            ':hover *': {
              color: 'inherit'
            },
            ':active': {
              background: theme.palette.neutralQuaternaryAlt
            },
            ':active *': {
              color: 'inherit'
            }
          }
        },
        size.isSize32 && {
          selectors: {
            '.ms-Persona-details': {
              paddingLeft: '12px'
            }
          }
        }
      ],
      primaryText: [
        {
          color: theme.palette.black,
          paddingTop: '1px'
        },
        size.isSize100 && {
          fontSize: FontSizes.size20,
          fontWeight: FontWeights.regular
        },
        size.isSize72 && {
          fontSize: FontSizes.size20
        },
        size.isSize48 && {
          fontSize: FontSizes.size16
        },
        size.isSize32 && {
          fontSize: FontSizes.size14
        }
      ],
      secondaryText: [
        {
          color: theme.palette.neutralDark,
          position: 'relative',
          top: '-2px'
        },
        size.isSize32 && {
          fontSize: FontSizes.size12
        }
      ],
      tertiaryText: {
        fontSize: FontSizes.size14
      }
    } as Partial<IPersonaStyles>;

    return styles;
  };
}
